import { fontFace } from 'typestyle';

fontFace({
    fontFamily: 'BentonSans-Book',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-Book.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Book.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'BentonSans-Book_Italic',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-Book_Italic.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Book_Italic.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'BentonSans-Medium',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-Medium.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Medium.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'BentonSans-SemiDemi',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-SemiDemi.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-SemiDemi.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'BentonSans-SemiDemi_Italic',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-SemiDemi_Italic.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-SemiDemi_Italic.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-Book.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Book.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans',
    fontWeight: 'normal',
    fontStyle: 'italic',
    src: 'url(img/BentonSans-Book_Italic.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Book_Italic.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans',
    fontWeight: 500,
    fontStyle: 'normal',
    src: 'url(img/BentonSans-SemiDemi.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-SemiDemi.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans',
    fontWeight: 'bold',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-Medium.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-Medium.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans Low-DPI',
    fontWeight: 'normal',
    fontStyle: 'normal',
    src: 'url(img/BentonSans-SemiDemi.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-SemiDemi.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});
fontFace({
    fontFamily: 'Benton Sans Low-DPI',
    fontWeight: 'normal',
    fontStyle: 'italic',
    src: 'url(img/BentonSans-SemiDemi_Italic.woff2?1_0_9606_yabs0uv7t1h) format(\'woff2\'), url(img/BentonSans-SemiDemi_Italic.woff?1_0_9606_yabs0uv7t1h) format(\'woff\')',
});